<template>
    <div class="table-wrapper" v-loading="loading" :element-loading-text="loadingText || '加载中...'">
        <table class="table">
            <Header :cols="config.columns" />
            <Body :rows="datas" :colNum="config.columns.length" @colClick="columnClick" />
        </table>
        <Footer
            v-show="!config.isHideFooter"
            :config="config"
            :total="total"
            :curPage="curPage"
            @checkAll="checkAllChange"
            :allCheck="allCheckFlag"
            @btnClick="bottomBtnClick"
            @pageChange="pageChange"
        />
    </div>
</template>

<script>
import Body from "./Body";
import Header from "./Header";
import Footer from "./Footer";


export default {
    name: "Table",
    components: {
        Body,
        Header,
        Footer
    },
    props: ["config", "dataset", "total", "curPage", "loading", "loadingText"],
    data() {
        return {
            datas: this.dataset ? this.computeDataset(this.dataset) : [],
            checkedRows: [],
            allCheckFlag: false
        };
    },
    watch: {
        dataset(curVal) {
            this.datas = curVal ? this.computeDataset(curVal) : [];
            this.initCheckedRows();
        }
    },
    mounted() {
        this.initCheckedRows();
    },
    methods: {
        // 计算每行的数据，由objec变成array，并按表头顺序排序
        computeDataset(dataset) {
            const columns = this.config.columns;

            return dataset.map(function(rowData) {
                return {
                    rowId: rowData.rowId,
                    translateServer: rowData.translateServer,
                    columns: columns.map(function(colSetting) {
                        return {
                            type: convertType(colSetting.type),
                            colId: colSetting.colId,
                            data: rowData[colSetting.colId] || getDefaultByType(colSetting.type),
                            component: colSetting.component
                        };
                    }),
                    addData: rowData.addData || null
                };
            });
        },
        initCheckedRows() {
            const self = this;

            this.datas.forEach(function(row) {
                row.columns.some(function(column, idx) {
                    const isFirstColumnCheckbox = idx === 0 && column.type === "Checkbox";
                    if (isFirstColumnCheckbox) {
                        self.updateCheckedRows(row.rowId, column.data);
                    }
                    return true;
                });
            });
        },
        // data={colId, type, rowData={rowId, columns}, [checked,] event}
        columnClick(data) {
            const columns = this.config.columns;

            if (data.type === "Checkbox") {
                // 更改内部状态
                this.updateCheckColumn(data.rowData.rowId, data.colId, data.checked);
            }

            // 向外发送事件
            this.$emit("columnClick", data);

            // config时设置的事件处理触发
            columns.some(function(column) {
                if (column.colId === data.colId) {
                    column.clickHandler && column.clickHandler(data);
                    return true;
                }
            });
        },
        checkAllChange(checked) {
            this.allCheckFlag = checked;
            checked ? this.allPageChecked() : this.removeAllChecked();
            this.updateAllCheckRow(checked);
        },
        removeAllChecked() {
            this.checkedRows.splice(0);
        },
        allPageChecked() {
            this.checkedRows.push(...this.datas.map(row => row.rowId));
        },
        removeCheckedRow(rowId) {
            let rowIdx = -1;
            this.checkedRows.some(function(row, idx) {
                if (row === rowId) {
                    rowIdx = idx;
                    return true;
                }
            });

            rowIdx != -1 && this.checkedRows.splice(rowIdx, 1);
        },
        updateCheckedRows(rowId, checked) {
            checked ? this.checkedRows.push(rowId) : this.removeCheckedRow(rowId);
            this.allCheckFlag = this.checkedRows.length === this.datas.length ? true : false;
        },
        updateAllCheckRow(checked) {
            let newDatas = this.datas.map(function(row) {
                row.columns = row.columns.map(function(column, idx) {
                    const isFirstColumnCheckbox = idx === 0 && column.type === "Checkbox";
                    if (isFirstColumnCheckbox && column.data !== checked) {
                        column.data = checked;
                        return Object.assign({}, column);
                    }

                    return column;
                });

                return Object.assign({}, row);
            });

            this.datas.splice(0, this.datas.length, ...newDatas);
        },
        updateCheckColumn(rowId, colId, checked) {
            const self = this;

            let newDatas = this.datas.map(function(row) {
                if (row.rowId === rowId) {
                    row.columns = row.columns.map(function(column, idx) {
                        if (column.colId === colId) {
                            column.data = checked;

                            if (idx === 0) {
                                self.updateCheckedRows(rowId, checked);
                            }

                            return Object.assign({}, column);
                        }

                        return column;
                    });
                    return Object.assign({}, row);
                }

                return row;
            });

            this.datas.splice(0, this.datas.length, ...newDatas);
        },
        // data={event, [option,] addData={}}
        bottomBtnClick(data) {
            const button = data.addData;

            let params = data.option ? [this.checkedRows, data.option, data.event] : [this.checkedRows, data.event];

            // config时设置的事件处理
            if (button.clickHandler && this.checkedRows.length) {
                button.clickHandler.apply(null, params);
            }

            // 向外发送事件
            this.$emit("bottomBtnClick", button.id, this.checkedRows, data.option);
        },
        pageChange(data) {
            // 向外发送事件
            this.$emit("pageChange", data);
        }
    }
};

// 根据columns的类型获取默认值
function getDefaultByType(type) {
    const defaults = {
        Link: "",
        Text: "",
        Checkbox: false,
        Custom: null
    };

    return defaults[type];
}

// 用户输入type转换为内部组件type
function convertType(type) {
    return !type || type === "Text" ? "PlatText" : type;
}
</script>

<style lang="less" scoped>
.table-wrapper {
    width: 100%;
    font-size: 12px;

    .table {
        width: 100%;
        table-layout: fixed;
    }
}
</style>
